var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMethodoLivrable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 41 51",
    id: "svg12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2"
  }, "Methodo_Livrable") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TaxAnalytics_Desk_FEC_01",
    transform: "translate(-174.000000, -2169.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MISSION",
    transform: "translate(158.000000, 1698.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Methodo_Livrable",
    transform: "translate(17.000000, 472.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-7",
    d: "m 13.5786,18.3217 4.779,4.779 7.499,-7.499 m 5.6058,3.9221 c 0,6.594 -5.345,11.939 -11.938,11.939 -6.594,0 -11.94,-5.345 -11.94,-11.939 0,-6.594 5.346,-11.939 11.94,-11.939 6.593,0 11.938,5.345 11.938,11.939 z M 21.394,0.726 22.875,2.08 c 0.666,0.61 1.586,0.856 2.467,0.662 L 27.303,2.31 C 28.704,2 30.109,2.812 30.542,4.18 l 0.606,1.913 c 0.272,0.861 0.946,1.534 1.806,1.807 l 1.914,0.605 c 1.368,0.433 2.179,1.838 1.87,3.24 l -0.432,1.96 c -0.194,0.881 0.052,1.801 0.661,2.467 l 1.354,1.482 c 0.969,1.058 0.969,2.681 0,3.74 l -1.354,1.481 c -0.609,0.666 -0.855,1.586 -0.661,2.468 l 0.432,1.96 c 0.309,1.401 -0.502,2.807 -1.87,3.239 l -1.914,0.606 c -0.86,0.272 -1.534,0.946 -1.806,1.807 l -0.606,1.913 c -0.433,1.368 -1.838,2.179 -3.239,1.87 l -1.961,-0.432 c -0.881,-0.194 -1.801,0.052 -2.467,0.661 l -1.481,1.355 c -1.059,0.967 -2.682,0.967 -3.74,0 l -1.482,-1.355 c -0.666,-0.609 -1.587,-0.855 -2.467,-0.661 l -1.96,0.432 c -1.402,0.309 -2.807,-0.502 -3.24,-1.87 L 7.9,32.955 C 7.627,32.094 6.954,31.42 6.093,31.148 L 4.18,30.542 C 2.812,30.11 2,28.704 2.309,27.303 l 0.433,-1.96 C 2.936,24.461 2.689,23.541 2.081,22.875 L 0.726,21.394 c -0.968,-1.059 -0.968,-2.682 0,-3.74 L 2.081,16.172 C 2.689,15.506 2.936,14.586 2.742,13.705 L 2.309,11.745 C 2,10.343 2.812,8.938 4.18,8.505 L 6.093,7.9 C 6.954,7.627 7.627,6.954 7.9,6.093 L 8.505,4.18 C 8.938,2.812 10.343,2 11.745,2.31 l 1.96,0.432 c 0.88,0.194 1.801,-0.052 2.467,-0.662 l 1.482,-1.354 c 1.058,-0.968 2.681,-0.968 3.74,0 z m 5.5088,36.0498 v 11.561 l -7.379,-4.524 -7.379,4.524 v -11.561"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMethodoLivrable);
export default __webpack_public_path__ + "static/media/Methodo_Livrable.c597dd3831b1aec4990906fe715da462.svg";
export { ForwardRef as ReactComponent };